/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
	{
		url: "/dashboard/maps",
		name: "Módulo Map",
		slug: "extra-component-maps-google-map",
		icon: "MapIcon",
		i18n: "Map",
	},
	{
		header: "Apps",
		icon: "PackageIcon",
		i18n: "Modules.Modules",
		items: [
			// CATEGORY OR OBJECT
			{
				url: "/apps/category",
				name: "OBJECTS",
				slug: "tipology-content",
				icon: "BoxIcon",
				i18n: "Objects",
				submenu: [
					{
						url: "/apps/resource/definition",
						name: "Definitions",
						slug: "app-resource-create",
						i18n: "CreateObject",
					},
					{
						url: "/apps/category/list",
						name: "List View",
						slug: "data-list-list-view",
						i18n: "ListOfObjects",
					},
				],
			},

			// RECURSOS
			{
				url: null,
				name: "RESOURCES",
				icon: "UserIcon",
				i18n: "Resources",
				submenu: [
					{
						url: "/apps/resource/resource-create",
						name: "Create",
						slug: "app-resource-create",
						i18n: "CreateResource",
						permission_id: 1,
						permission_name: "RESOURCES_C",
					},
					{
						url: "/apps/resource/resource-list",
						name: "List",
						slug: "app-resource-list",
						i18n: "List",
					},
				],
			},
			// VISIT POINT
			{
				url: null,
				name: "VISIT_POINT",
				icon: "MapPinIcon",
				i18n: "VisitPoint",
				submenu: [
					{
						url: "/apps/visit-point/create",
						name: "Create",
						slug: "app-visit-point-create",
						i18n: "CreateVisitPoint",
					},
					{
						url: "/apps/visit-point/visit-point-list",
						name: "List",
						slug: "app-resource-list",
						i18n: "List",
					},
				],
			},
			{
				url: "/app/group/group-list",
				name: "GROUPS",
				tagColor: "primary",
				icon: "UsersIcon",
				i18n: "Groups.Groups",
				permission_id: 15,
				permission_name: "GROUPS_R",
			},
			{
				url: "/apps/activity",
				name: "ACTIVITY",
				tagColor: "primary",
				icon: "TagIcon",
				i18n: "Activity.Activity",
			},
			{
				url: null,
				name: "CALENDAR",
				slug: "resource-calendar",
				icon: "CalendarIcon",
				tagColor: "success",
				i18n: "Calendar",
				submenu: [
					{
						url: "/apps/calendar/resource-calendar",
						name: "ViewCalendar",
						slug: "app-visit-point-create",
						i18n: "Schedule.ViewCalendar",
					},
					{
						url: "/apps/calendar/create-event",
						name: "VisitScheduling",
						slug: "app-resource-list",
						i18n: "Schedule.ScheduleVisits",
					},
					{
						url: "/apps/calendar/follower/create",
						name: "Follower",
						slug: "app-calendar-follower",
						i18n: "Follower.AddFollowers",
					},
					{
						url: "/apps/calendar/follower/list",
						name: "Follower",
						slug: "app-calendar-follower",
						i18n: "Follower.FollowersList",
					},
				],
			},
			// Zonification
			{
				url: "/apps/zonification",
				name: "ZONIFICATION",
				slug: "resource-zonification",
				icon: "LayersIcon",
				tagColor: "success",
				i18n: "Zonification.Zonification",
			},
			// ALARMS
			{
				url: "/apps/category",
				name: "ALARMS",
				slug: "tipology-content",
				icon: "ClockIcon",
				i18n: "Alarm.Alarms",
				submenu: [
					{
						url: "/apps/alarm/battery",
						name: "Battery",
						slug: "app-alarm-battery",
						i18n: "Alarm.BatteryAlarms",
					},
					{
						url: "/apps/alarm/gps",
						name: "Gps",
						slug: "data-alarm-gps",
						i18n: "Alarm.GpsAlarms",
					},
					{
						url: "/apps/alarm/radio",
						name: "Radio",
						slug: "data-alarm-radio",
						i18n: "Alarm.RadioAlarm",
					},
					{
						url: "/apps/alarm/schedule",
						name: "Schedule",
						slug: "data-alarm-gps",
						i18n: "Alarm.ScheduleAlarms",
					},
					{
						url: "/apps/alarm/zone",
						name: "Zone",
						slug: "data-alarm-gps",
						i18n: "Alarm.ZoneAlarms",
					},
					{
						url: "/apps/alarm/speed",
						name: "Speed",
						slug: "data-alarm-speed",
						i18n: "Alarm.SpeedAlarm",
					},
				],
			},
			// Upload File
			{
				url: "/apps/UploadFiles",
				name: "UPLOAD_FILES",
				slug: "resource-upload-files",
				icon: "UploadIcon",
				tagColor: "success",
				i18n: "UploadFiles.UploadFiles",
			},
			// Reports
			{
				name: "REPORTS",
				slug: "reports-files",
				icon: "FileTextIcon",
				tagColor: "success",
				i18n: "Reports.Reports",
				submenu: [
					{
						url: "/apps/reports",
						name: "Battery",
						slug: "reports-files",
						i18n: "Reports.Generate",
					},
					{
						url: "/apps/reports/list",
						name: "Gps",
						slug: "reports-files",
						i18n: "Reports.History",
					},
				],
			},
			// Indicators
			{
				url: "/apps/indicator",
				name: "INDICATORS",
				slug: "indicator",
				icon: "TrelloIcon",
				tagColor: "success",
				i18n: "Indicators.Indicators",
			},
			// Communication
			{
				url: "/apps/communication",
				name: "COMMUNICATION",
				slug: "Communication",
				icon: "MessageSquareIcon",
				i18n: "Communication.Communication",
				tag: "0",
				tagColor: "warning",
			},
			{
				url: "/apps/on-demand",
				name: "ONDEMAND",
				slug: "OnDemand",
				icon: "ShoppingBagIcon",
				i18n: "OnDemand.OnDemand",
				tag: "0",
				tagColor: "warning",
			},
			{
				url: "/apps/massive-assignment",
				name: "MASSIVE_ASSIGNMENT",
				slug: "todo",
				icon: "CheckSquareIcon",
				i18n: "MassiveAssignment.MassiveAssignment",
				tag: "0",
				tagColor: "success",
			},
			{
				url: "/apps/chat",
				name: "CHAT",
				slug: "chat",
				icon: "MessageCircleIcon",
				tag: "0",
				i18n: "Chat.Chat",
				tagColor: "warning",
			},
		],
	},
	{
		header: "Servi Apps",
		icon: "ConfigIcon",
		i18n: "Apps",
		items: [
			// ServiForm
			{
				url: "/apps/serviform",
				name: "SERVIFORMS",
				slug: "Serviforms",
				icon: "ClipboardIcon",
				tagColor: "success",
				i18n: "Serviform",
			},
			// ServiRoute
			{
				url: "/apps/serviroute",
				name: "SERVIROUTES",
				slug: "ServiRoutes",
				icon: "TrendingUpIcon",
				tagColor: "success",
				i18n: "ServiRoutes",
			},
		],
	},
	{
		header: "Config",
		icon: "ConfigIcon",
		i18n: "Config",
		items: [
			{
				url: "/dashboard/company",
				name: "COMPANY",
				slug: "extra-component-maps-google-map",
				icon: "BriefcaseIcon",
				i18n: "Company",
			},
			{
				url: "/dashboard/setting",
				slug: "Setting",
				name: "Setting",
				icon: "ToolIcon",
				i18n: "CompanySettings",
			},
			{
				url: "/dashboard/session-api",
				slug: "Setting",
				name: "SESSION_API",
				icon: "KeyIcon",
				i18n: "SessionApi.SessionApi",
			},
			{
				url: "/dashboard/type-config-crud",
				slug: "Type Config",
				name: "TYPE_CONFIG",
				icon: "SettingsIcon",
				i18n: "TypeConfig",
			},
			{
				url: "/dashboard/roles",
				slug: "Roles",
				name: "ROLE",
				icon: "UsersIcon",
				i18n: "Roles.Roles",
			},
			{
				url: "/dashboard/permissions",
				slug: "Permissions",
				name: "Permissions",
				icon: "LockIcon",
				i18n: "Permissions.Permissions",
			},
			{
				url: "/dashboard/status",
				slug: "StatusModule",
				name: "Status",
				icon: "BarChartIcon",
				i18n: "StatusModule.StatusLink",
			},
			{
				url: "/dashboard/status-mobile",
				slug: "StatusMobile",
				name: "StatusMobile",
				icon: "SmartphoneIcon",
				i18n: "StatusMobile.StatusMobile",
			},
			// TYPOLOGY
			{
				url: "/apps/tipology",
				name: "TYPOLOGY",
				slug: "tipology-content",
				icon: "TagIcon",
				i18n: "Tipology",
			},
		],
	},
	{
		header: "\n",
		icon: "",
		i18n: "",
		items: [],
	},
];
